import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import SectionTitle from 'core/modules/SectionTitle/SectionTitle';
import MarketingMotto from 'core/modules/Partials/MarketingMotto/MarketingMotto';
import { selectIsMobileMQ, selectIsDesktopMQ } from 'core/modules/MediaQueries/selectors';
import FeaturedDeal from './components/FeaturedDeal/FeaturedDeal';
import ContentWrap from 'core/modules/Partials/ContentWrap/ContentWrap';
import List from 'core/modules/Partials/List/List';
import { triggerFeaturedDealsIsViewed } from './actions';
import { selectFeaturedDealsConfig } from './selectors';
import { useGetContent, useGetHeading } from './hooks';

import './FeaturedDeals.scss';

function FeaturedDeals({ customClass = '' }) {
  const dispatch = useDispatch();
  const config = useSelector(selectFeaturedDealsConfig);
  const isMobileMQ = useSelector(selectIsMobileMQ);
  const isDesktopMQ = useSelector(selectIsDesktopMQ);

  const { dealsToDisplay } = useGetContent();
  const { headingData } = useGetHeading();

  const { sectionTitle, viewAllLinkText, clickUrl } = headingData;

  const {
    getMotto, checkShouldUseCarousel, contentWrap, carousel,
  } = config;
  const motto = getMotto(isMobileMQ);

  const hasContentToShow = !isEmpty(dealsToDisplay) && !isEmpty(headingData);

  useEffect(() => {
    if (hasContentToShow) {
      dispatch(triggerFeaturedDealsIsViewed(dealsToDisplay));
    }
  }, [hasContentToShow]);

  if (!hasContentToShow) {
    return null;
  }
  const shouldUseCarousel = checkShouldUseCarousel(isMobileMQ);

  return (
    <div
      className={`mn_featuredDeals ${customClass}`}
      data-item-count={dealsToDisplay.length}
      data-testid="featured-deals"
    >
      <ContentWrap {...contentWrap}>
        <MarketingMotto motto={motto} />
        <SectionTitle title={sectionTitle}>
          { !isMobileMQ && <a className="mn_viewAllLink" href={clickUrl}>{viewAllLinkText}</a> }
        </SectionTitle>
        <div className="mn_featuredDealsContainer">
          <List
            options={carousel}
            shouldUseCarousel={shouldUseCarousel}
            hasFillers={isDesktopMQ ? 4 : 3}
          >
            {dealsToDisplay.map(offer => (
              <FeaturedDeal offer={offer} key={`${offer.id}`} config={config} />
            ))}
          </List>
        </div>
        {isMobileMQ &&
          <a className="mn_button mn_secondaryButton" href={clickUrl} title={viewAllLinkText}>
            {viewAllLinkText}
          </a>
        }
      </ContentWrap>
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><FeaturedDeals {...props} /></ComponentErrorBoundary>;
